import { hora } from '../lib/formato.js'

/**
 * Banner de "em edicao por fulano".
 *
 * "Assumir edicao" so aparece habilitado DEPOIS que o lock expira — antes
 * disso, assumir seria roubar a edicao de alguem que esta digitando agora.
 *
 * `expirado` vem de fora: quem conta o tempo e o Editor, porque a mesma
 * contagem tambem decide se o botao Publicar fica bloqueado. Dois relogios
 * independentes acabariam discordando.
 */
export function BannerLock({ lock, expirado, podeEditar, podePublicar, aoAssumir, ocupado }) {
  if (!lock) return null

  return (
    <div className={`banner ${expirado ? 'banner--expirado' : 'banner--bloqueado'}`}>
      <div>
        <strong>{expirado ? 'Edição expirada' : 'Em edição'}</strong> por {lock.detentor}
        {expirado ? (
          <span className="banner__detalhe"> — o bloqueio expirou às {hora(lock.expiraEm)}</span>
        ) : (
          <span className="banner__detalhe"> — expira ~{hora(lock.expiraEm)}</span>
        )}
        <div className="banner__detalhe">
          Você está em modo leitura.
          {!expirado && podePublicar && ' Publicar fica bloqueado enquanto a edição estiver ativa: o texto ainda pode mudar.'}
        </div>
      </div>

      {podeEditar && (
        <button
          className="botao botao--primario"
          onClick={aoAssumir}
          disabled={!expirado || ocupado}
          title={expirado ? 'Assumir a edição deste agente' : 'Disponível quando o bloqueio expirar'}
        >
          {ocupado ? 'Assumindo…' : 'Assumir edição'}
        </button>
      )}
    </div>
  )
}
